<template>
  <div id="modalOverlay">
      <div id="modalWindow">
        <div class="row">
          <div class="col-sm-12" style="margin-bottom: 15px;">
            <h3>Edit Leak</h3>
          </div>
        </div>
        <form @submit.prevent="editLeakCheck">
        <div class="row">
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-4">
                <label>Date</label>
              </div>
              <div class="col-sm-8">
                <date-picker
                  v-model="leak.date"
                  format="YYYY-MM-DD"
                  type="date"
                  valueType="format"
                ></date-picker>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-4">
                <label>Engineer</label>
              </div>
              <div class="col-sm-8">
                <div class="commerceSelect">
                  <select v-model="leak.engineer">
                    <option value="Will Rae">Will Rae</option>
                    <option value="Ben White">Ben White</option>
                    
                  </select>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-sm-4">
                <label>Result</label>
              </div>
              <div class="col-sm-8">
                <input type="text" class="text" v-model="leak.result" />
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="row">
              <div class="col-sm-4">
                <label>Further work</label>
              </div>
              <div class="col-sm-8">
                <textarea v-model="leak.further" rows="5"></textarea>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div align="right">
                  <input type="submit" value="Save Leak Check" />
                </div>
              </div>
            </div>
          </div>
        </div>
        </form>
        <router-link :to="{name: 'AssetsLeak', params: { id: this.$route.params.id }}"><font-awesome-icon icon="plus" class="modalClose" /></router-link>
      </div>
    </div>
</template>

<script>

import axios from 'axios'

import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
  components: { DatePicker },
  data () {
    return {
      leak: {}
    }
  },
  created () {
    axios
      .get(`/api/fgas/leakcheck/${this.$route.params.aid}`)
      .then((res) => {
        this.leak = res.data
      })
  },
  methods: {
    editLeakCheck () {
      axios
        .put(`/api/fgas/leakcheck/${this.$route.params.aid}`, this.leak)
        .then(response => (
          this.$toast.success("Leak check saved", {}),
          this.$router.push({ name: 'AssetsLeak', params: { id: this.$route.params.id } })
        ))
        .catch(err => console.log(err))
        // .finally(() => this.loading = false)
    }
  }
}
</script>
